module.exports = "<work-modal-create></work-modal-create>\n<work-modal-edit></work-modal-edit>\n<work-modal-delete></work-modal-delete>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/component/work/modal/work-modal.cmp.html
 ** module id = 411
 ** module chunks = 0
 **/